import styled from 'styled-components';
import { BoxProps, Div } from '../box';

const SubHeader = styled(({ ...rest }) => <Div variant={'white'} {...rest} />)<BoxProps>`
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.32);
`;

export default SubHeader;
